// Chart.js v3 requires every element/scale/plugin it uses to be explicitly registered.
// vue-chartjs 4.x (imported from 'vue-chartjs/legacy' in the ENPS chart components) already
// registers each chart type's own controller itself (Chart.register(chartController) in its
// created() hook) — but NOT the elements/scales/plugins those controllers draw with, so those
// still need registering here or the charts render blank.
//
// Title и Filler намеренно не регистрируются: заголовки всех графиков — обычные HTML-элементы,
// а заливки под линиями (fill у датасетов) нигде нет.
import {
    Chart,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    BarElement,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

Chart.register(LineElement, PointElement, LinearScale, CategoryScale, BarElement, ArcElement, Tooltip, Legend);
